export const INITIAL_COORDINATES = { x: 0, y: 0 };

export const DRAWING_CONSTANTS = {
  BRUSH: {
    MIN_SIZE: 1,
    MAX_SIZE: 100,
    DEFAULT_SIZE: 20,
    COLOR: "#eb7100",
  },
  CANVAS: {
    LINE_CAP: "round",
    COMPOSITE_OPERATIONS: {
      DRAW: "source-over",
      ERASE: "destination-out",
    },
  },
} as const;
